import { WORKSHEET_CLASSES } from '../constants/classNames';

/**
 * Opens the browser's print dialog, where the page can be printed or saved as a PDF.
 */
export default function PrintButton({ label = 'Print this page' }) {
  const printPage = () => window.print();
  return (
    <button type="button" className={WORKSHEET_CLASSES.printButton} onClick={printPage}>
      🖨️ {label}
    </button>
  );
}
